<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,0C15,0,5,0,5,0C4.45,0,4,0.45,4,1C4,1,4,3,4,3C4,3,6,3,6,3C6,3,6,2,6,2C6,2,14,2,14,2C14,2,14,9,14,9C14,9,13,9,13,9C13,9,13,11,13,11C13,11,15,11,15,11C15.55,11,16,10.55,16,10C16,10,16,1,16,1C16,0.45,15.55,0,15,0C15,0,15,0,15,0ZM11,4C11,4,1,4,1,4C0.45,4,0,4.45,0,5C0,5,0,15,0,15C0,15.55,0.45,16,1,16C1,16,11,16,11,16C11.55,16,12,15.55,12,15C12,15,12,5,12,5C12,4.45,11.55,4,11,4C11,4,11,4,11,4ZM10,14C10,14,2,14,2,14C2,14,2,6,2,6C2,6,10,6,10,6C10,6,10,14,10,14C10,14,10,14,10,14Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Duplicate',
} as DefineComponent
</script>
